import {Grid, PassportIcon, Typography} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import React from 'react'

import {isPostOffice} from '../../utils/is-post-office'
import {useDetails} from '../use-details'
import {PaymentTitle} from './PaymentTitle/PaymentTitle'
import {classes} from './PickupPointDetails.classes'
import type {Props} from './types'

export function PickupPointDetails(props: Props) {
  const {point} = props
  const {time, schedule} = useDetails(point)
  const i18n = useI18n()

  return (
    <Grid className={classes.root} size="s" container>
      {isPostOffice(point?._type) && (
        <Grid alignItems="center" className={classes.passportNeed} size="m" container item>
          <Grid item>
            <PassportIcon fill="none" />
          </Grid>
          <Grid item>{i18n('ndd.pickup_points.passport_need', 'Для получения посылки нужен паспорт')}</Grid>
        </Grid>
      )}

      <Grid alignItems="center" justify="space-between" wrap="nowrap" container item>
        <Grid item xs>
          <Typography group="tight" variant="body2">
            {i18n('ndd.pickup_points.storage_time', 'Срок хранения')}
          </Typography>
        </Grid>
        <Grid alignItems="flex-end" direction="column" container item xs>
          <Typography group="tight" variant="body2">
            {time}
          </Typography>
        </Grid>
      </Grid>

      <Grid justify="space-between" wrap="nowrap" container item>
        <Grid item xs>
          <Typography group="tight" variant="body2">
            {i18n('ndd.pickup_points.schedule', 'График работы')}
          </Typography>
        </Grid>
        <Grid alignItems="flex-end" direction="column" container item xs>
          {schedule.map((str, idx) => (
            <Typography key={String(idx)} Component={Grid} group="tight" variant="body2" whiteSpace="nowrap">
              {str}
            </Typography>
          ))}
        </Grid>
      </Grid>

      <Grid justify="space-between" wrap="nowrap" container item>
        <Grid item xs>
          <Typography group="tight" variant="body2">
            {i18n('ndd.pickup_points.payment_methods', 'Способы оплаты')}
          </Typography>
        </Grid>
        <Grid alignItems="flex-end" direction="column" container item xs>
          {point?.paymentMethods.map(method => <PaymentTitle key={method} method={method} />)}
        </Grid>
      </Grid>
    </Grid>
  )
}
